import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isDate } from './is-date';

export const isDateAfterMaxDate = (value: Date, maxDate: Date) => {
  const currentValueWithoutTime = new Date(value);
  currentValueWithoutTime.setHours(0, 0, 0, 0);
  maxDate.setHours(0, 0, 0, 0);
  return currentValueWithoutTime.getTime() > maxDate.getTime();
};

export const isDateBeforeMinDate = (value: Date, minDate: Date) => {
  const currentValueWithoutTime = new Date(value);
  currentValueWithoutTime.setHours(0, 0, 0, 0);
  minDate.setHours(0, 0, 0, 0);
  return currentValueWithoutTime.getTime() < minDate.getTime();
};

export const MaxDate =
  (maxDate: Date) =>
  (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || !isDate(value)) {
      return null;
    }

    return isDateAfterMaxDate(value, maxDate) ? { maxDate: true } : null;
  };

export const MinDate =
  (minDate: Date) =>
  (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || !isDate(value)) {
      return null;
    }

    return isDateBeforeMinDate(value, minDate) ? { minDate: true } : null;
  };

export const getNowUTCDate = (): Date => {
  const now = new Date();

  return new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );
};

export const getYesterdayUTCDate = (): Date => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return new Date(
    Date.UTC(
      yesterday.getUTCFullYear(),
      yesterday.getUTCMonth(),
      yesterday.getUTCDate()
    )
  );
};

export const getCurrentMonthUTCDate = (): Date => {
  const now = new Date();
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
};
